import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Skeleton,
  Container
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import adCenterApi from '../adCenterApi';
import { showToast } from '../CoreDataService';

export default function ViewSpendCaps() {
  const [spendCaps, setSpendCaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchSpendCaps = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await adCenterApi.post('/getSpendCapByBroker', { brokerId: localStorage.getItem('brokerId') });
      if (response.data && response.data.statusCode === 0 && response.data.spendCapDetails) {
        setSpendCaps(Array.isArray(response.data.spendCapDetails) ? response.data.spendCapDetails : [response.data.spendCapDetails]);
      } else {
        setSpendCaps([]);
        setError(response.data.message || 'No spend caps found');
      }
    } catch (err) {
      setError('Error fetching spend caps');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSpendCaps();
  }, []);

  const handleEdit = (row) => {
  console.log("Edit row:", row);

  if (row.isInUse == 1) {
    const confirmed = window.confirm(
      "Your Spend cap is being used in an active Campaign. Your updated Spend cap will become effective after UTC 12:00AM today. Do you want to continue?"
    );

    if (confirmed) {
      navigate("/editSpendCaps", { state: { spendCap: row } });
    }
  } else {
    navigate("/editSpendCaps", { state: { spendCap: row } });
  }
};

  const handleDelete = async (row) => {
    try {
      const response = await adCenterApi.post('/modifySpendCap', {
        ...row,
        adminUser: localStorage.getItem('uuid'),
        brokerId: localStorage.getItem('brokerId'),
        action: 'DELETE',
      });
      if (response.data && response.data.statusCode === 0) {
        showToast('success', 'Spend cap deleted successfully!');
        fetchSpendCaps();
      } else {
        showToast('error', response.data.message || 'Failed to delete spend cap');
      }
    } catch (err) {
      showToast('error', 'Error deleting spend cap');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mb: 6 }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1 }}>
          <Box>
            <Typography variant="h4" component="h1" fontWeight="bold" color="primary.main">
              Spend Caps
            </Typography>
            <Typography variant="body1" color="text.secondary" mt={0.5} sx={{ fontStyle: 'italic' }}>
              View and manage all your spend caps in one place.
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 'bold', textTransform: 'none', boxShadow: 2 }}
            onClick={() => navigate('/spend-caps')}
          >
            Create Spend Cap
          </Button>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Card elevation={6} sx={{ borderRadius: 3, boxShadow: 6 }}>
            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
              {loading ? (
                <Stack spacing={2}>
                  {[...Array(5)].map((_, i) => (
                    <Skeleton key={i} variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
                  ))}
                </Stack>
              ) : error ? (
                <Typography color="error">{error}</Typography>
              ) : (
                <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: 'grey.900' }}>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Name</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Amount</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Currency</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {spendCaps.map((row, idx) => (
                        <TableRow key={row.spendCapsId || idx} hover>
                          <TableCell>{row.spendCapsName || '-'}</TableCell>
                          <TableCell>{row.spendCapsAmount || '-'}</TableCell>
                          <TableCell>{row.currency || '-'}</TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                              <Button variant="outlined" color="primary" size="small" sx={{ fontWeight: 'bold', borderRadius: 2 }}
                                onClick={() => handleEdit(row)}>
                                Edit
                              </Button>
                              <Button variant="outlined" color="error" size="small" sx={{ fontWeight: 'bold', borderRadius: 2 }}
                                onClick={() => handleDelete(row)}>
                                Delete
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Container>
  );
}
